import Cookies from 'js-cookie'

export const initialState = {
  loading: false,
  softwareLinks: {}
}

export const UPDATE_SOFTWARE_LINKS_REQUEST = 'UPDATE_SOFTWARE_LINKS_REQUEST'
export const UPDATE_SOFTWARE_LINKS_SUCCESS = 'UPDATE_SOFTWARE_LINKS_SUCCESS'
export const UPDATE_SOFTWARE_LINKS_ERROR = 'UPDATE_SOFTWARE_LINKS_ERROR'

export const getEmailTemplate = name => (dispatch, getState, { httpRequest }) => {
  return httpRequest.get(`/get-email-template/${name}`)
    .then(res => {
      return Promise.resolve(res.data)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getCSRF = () => (dispatch, getState, { httpRequest }) => {
  return httpRequest.get('/csrf-token')
    .then(res => {
      Cookies.set('XSRF-TOKEN', res.data.token)
      return Promise.resolve(res.data)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

const ACTION_HANDLERS = {
  [UPDATE_SOFTWARE_LINKS_SUCCESS]: (state, { softwareLinks }) => ({
    ...state,
    softwareLinks
  })
}

export default function(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/global.js